import { render, staticRenderFns } from "./ChoiceModule.vue?vue&type=template&id=6271240e&scoped=true&"
import script from "./ChoiceModule.vue?vue&type=script&lang=js&"
export * from "./ChoiceModule.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceModule.vue?vue&type=style&index=0&id=6271240e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6271240e",
  null
  
)

export default component.exports